import _ from 'lodash'

const DEBOUNCE_WAIT_TIME = 400

export const debounce = (fn, options, wait = DEBOUNCE_WAIT_TIME) => _.debounce(fn, wait, options)
